import { render } from "./CounselorsForm.vue?vue&type=template&id=0d7822b6"
import script from "./CounselorsForm.vue?vue&type=script&lang=js"
export * from "./CounselorsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__